import request from '@/service/request';

export const getCommissions = (data: any) => {
  return request.get('/v1/agency-platform-vn-v2/agency/commissions', {
    params: data,
  });
};

export const getCommissionBalance = () => {
  return request.get('/v1/agency-platform-vn-v2/agency/commission_info');
};

export const getCashHistory = (data: any) => {
  return request.get('/v1/agency-platform-vn-v2/agency/my_withdrawals', {
    params: data,
  });
};

export const getAccounts = () => {
  return request.get('/v1/agency-platform-vn-v2/agency/bank_accounts');
};

export const goWithdraw = (data: any) => {
  return request.post('/v1/agency-platform-vn-v2/agency/withdraw', { data });
};
